import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * 性能优化组件
 * 包含预加载、预连接、DNS预解析等优化
 */
export const PerformanceOptimizer: React.FC = () => {
  useEffect(() => {
    // 预加载关键资源
    const preloadCriticalResources = () => {
      // 预加载字体
      const fontLink = document.createElement('link');
      fontLink.rel = 'preload';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
      fontLink.as = 'style';
      fontLink.crossOrigin = 'anonymous';
      document.head.appendChild(fontLink);

      // 预加载关键图片
      const logoImg = new Image();
      logoImg.src = '/logo.png';
      
      const ogImg = new Image();
      ogImg.src = '/og-image.png';
    };

    // 延迟加载非关键资源
    const loadNonCriticalResources = () => {
      // 延迟加载分析脚本
      setTimeout(() => {
        // Google Analytics (如果需要)
        // const script = document.createElement('script');
        // script.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
        // script.async = true;
        // document.head.appendChild(script);
      }, 3000);
    };

    // 页面加载完成后执行优化
    if (document.readyState === 'complete') {
      preloadCriticalResources();
      loadNonCriticalResources();
    } else {
      window.addEventListener('load', () => {
        preloadCriticalResources();
        loadNonCriticalResources();
      });
    }

    // Service Worker 注册 (如果需要PWA功能)
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  return (
    <Helmet>
      {/* DNS预解析 */}
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
      <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
      <link rel="dns-prefetch" href="https://www.google-analytics.com" />
      <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
      
      {/* 预连接到关键第三方域名 */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* 预加载关键CSS */}
      <link 
        rel="preload" 
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" 
        as="style" 
        onLoad="this.onload=null;this.rel='stylesheet'" 
      />
      
      {/* 预加载关键图片 */}
      <link rel="preload" href="/logo.png" as="image" />
      <link rel="preload" href="/og-image.png" as="image" />
      
      {/* 资源提示 */}
      <meta httpEquiv="x-dns-prefetch-control" content="on" />
      
      {/* 性能相关的meta标签 */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="format-detection" content="date=no" />
      <meta name="format-detection" content="address=no" />
      <meta name="format-detection" content="email=no" />
      
      {/* 移动端优化 */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="ToolKit Club" />
      
      {/* PWA相关 */}
      <link rel="manifest" href="/site.webmanifest" />
      <meta name="theme-color" content="#3B82F6" />
      <meta name="msapplication-TileColor" content="#3B82F6" />
      <meta name="msapplication-config" content="/browserconfig.xml" />
      
      {/* 安全相关 */}
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      <meta httpEquiv="X-Frame-Options" content="DENY" />
      <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
      <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
      
      {/* 缓存控制 */}
      <meta httpEquiv="Cache-Control" content="public, max-age=31536000" />
    </Helmet>
  );
};
